import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { ViLoaderComponent } from '../../../../../projects/ui';
import { CommonStandaloneModule } from '../../../common-standalone.module';
import { ServiceTicketFeedbackComponent } from './service-ticket-feedback/service-ticket-feedback.component';
import { ServiceTicketCallTypeComponent } from './service-ticket-call-type/service-ticket-call-type.component';
import { ServiceTicketCallResultComponent } from './service-ticket-call-result/service-ticket-call-result.component';
import { ServiceTicket, ServiceTicketStore } from '../../../../@store';
import { ServiceTicketArrangedCallResultComponent } from './service-ticket-arranged-call-result/service-ticket-arranged-call-result.component';
@Component({
  selector: 'app-service-ticket-page-call',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    LetDirective,
    ViLoaderComponent,
    ServiceTicketFeedbackComponent,
    ServiceTicketCallTypeComponent,
    ServiceTicketCallResultComponent,
    ServiceTicketArrangedCallResultComponent,
  ],
  templateUrl: './service-ticket-page-call.component.html',
  styleUrls: ['./service-ticket-page-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketPageCallComponent {
  CallPageSteps = ServiceTicket.CallPageSteps;

  constructor(public serviceTicketStore: ServiceTicketStore) {}
}
